export function getPostAuthDestination() {
  // CoreAccessRoute owns the authoritative subscription preflight. Sending
  // every iOS session through the paywall first causes active subscribers to
  // flash an unnecessary intermediate screen during app startup.
  return '/dashboard'
}
